import { useEffect, useState } from "react";
import { BoatEdit } from "./boat-edit";
import { BoatInfoDisplay } from "./boat-info-display";
import BoatAdd from "./boat-add";
import { Button } from "../../../components/button";
import { useNavigate, useLocation } from "react-router-dom";
import { TeamWithDetails } from "../../../types/team.types";

export interface IBoatInfoPrimaryUserProps {
  team: TeamWithDetails;
}

export function BoatInfoPrimaryUser({ team }: IBoatInfoPrimaryUserProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleCancel = () => {
    navigate("#");
  };

  useEffect(() => {
    const handleHashChange = () => {
      setIsEditing(location.hash === "#edit");
      setIsCreating(location.hash === "#create");
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [location.hash]);

  const handleCreate = () => {
    navigate("#create");
  };

  const handleEdit = () => {
    navigate("#edit");
  };

  return (
    <div>
      {isEditing ? (
        <BoatEdit onCancel={handleCancel} team={team} />
      ) : isCreating ? (
        <BoatAdd onCancel={handleCancel} />
      ) : team?.boat ? (
        <div>
          <BoatInfoDisplay team={team} />
          <Button
            onClick={handleEdit}
            text="Editar"
            variant="edit"
            className="mt-4"
          />
        </div>
      ) : (
        <div>
          <p className="text-gray-500 italic">
            No hay una embarcación registrada. ¡Crea una!
          </p>
          <Button
            onClick={handleCreate}
            text="Crear"
            variant="create"
            className="mt-4"
          />
        </div>
      )}
    </div>
  );
}
